var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CONFIG } from "../../config/app.config";
import { ETemplateDocumentStatus } from "../../types/contract.types";
import { CONTRACT_TEMPLATE_TYPES } from "./templateDocument.constants";
// The document overview lists template documents that still need a PDF, so only the statuses
// without a finished document are shown. Archived and non-archived are mutually exclusive views.
var PENDING_STATUSES = [
    ETemplateDocumentStatus.New,
    ETemplateDocumentStatus.Failed,
];
var ARCHIVED_STATUSES = [
    ETemplateDocumentStatus.New,
    ETemplateDocumentStatus.Generating,
    ETemplateDocumentStatus.Failed,
];
var getSearchValue = function (search) {
    return search === "" ? undefined : search;
};
export var getTemplateDocumentsQuery = function (params) {
    var _a = params.page, page = _a === void 0 ? 1 : _a, _b = params.limit, limit = _b === void 0 ? CONFIG.DEFAULT_FETCH_LIMIT : _b, extraFilterData = params.extraFilterData, search = params.search;
    return {
        page: page,
        limit: limit,
        filter: __assign({}, extraFilterData),
        search: getSearchValue(search),
    };
};
export var getDocumentOverviewQuery = function (params) {
    var page = params.page, isArchived = params.isArchived, extraFilterData = params.extraFilterData, search = params.search;
    return getTemplateDocumentsQuery({
        page: page,
        search: search,
        extraFilterData: __assign(__assign({}, extraFilterData), { status: { in: isArchived ? ARCHIVED_STATUSES : PENDING_STATUSES }, archivedAt: isArchived ? { isNot: null } : { is: null } }),
    });
};
export var getContractTemplateDocumentsQuery = function (params) {
    var contractId = params.contractId;
    return getTemplateDocumentsQuery({
        extraFilterData: {
            contractId: { eq: contractId },
            type: { in: CONTRACT_TEMPLATE_TYPES },
        },
    });
};
export var getPropertyTemplateDocumentsQuery = function (params) {
    var propertyId = params.propertyId, type = params.type;
    return getTemplateDocumentsQuery({
        extraFilterData: {
            propertyId: { eq: propertyId },
            type: { in: type === "contract" ? CONTRACT_TEMPLATE_TYPES : type },
        },
    });
};
export var getTemplateDocumentsCountQuery = function (params) {
    var propertyId = params.propertyId;
    return {
        filter: {
            propertyId: { eq: propertyId },
            status: { in: PENDING_STATUSES },
            archivedAt: { is: null },
        },
    };
};
export var getSignatureReferenceForAccountId = function (accountId) {
    return "#REN".concat(accountId, "_").concat(100, "_").concat(200, "#");
};
